import { render, staticRenderFns } from "./pages5.vue?vue&type=template&id=cdf88d1a&scoped=true&"
import script from "./pages5.vue?vue&type=script&lang=js&"
export * from "./pages5.vue?vue&type=script&lang=js&"
import style0 from "./pages5.vue?vue&type=style&index=0&id=cdf88d1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf88d1a",
  null
  
)

export default component.exports